// Get backend URL from environment variable or use default
export const baseuRL = process.env.REACT_APP_BACK_END_URL || "http://localhost:5001"

// Validate that backend URL is set (only log warning, don't block)
if (!process.env.REACT_APP_BACK_END_URL && process.env.NODE_ENV === 'production') {
  console.warn('Warning: REACT_APP_BACK_END_URL is not set. Using default: http://localhost:5001');
  console.warn('Please set REACT_APP_BACK_END_URL environment variable in production!');
}